import api from '../../services/api'

export const getUpsellableFields = async ({commit, state, rootState}) => {
  let response = await api.userService.getUpsellableUserFields(rootState.parantion.user.user.uh)

  rootState.parantion.user.user.account_valid = response.account_valid
  rootState.parantion.user.user.forms_granted = response.forms_granted
  rootState.parantion.user.user.forms_used = response.forms_used
  rootState.parantion.user.user.nonamed_users_granted = response.nonamed_users_granted
  rootState.parantion.user.user.nonamed_users_used = response.nonamed_users_used
}
